export function isInvalidSharedRegime(
    tree,
    share,
    search = window.location.search,
    pathname = window.location.pathname,
    treeIndexMatchesClient = true
) {
    const schedulePrint = new URLSearchParams(search).get("schedulePrint")

    // null is the tree index's initial loading result. Once indexing has completed, a
    // genuinely missing regime resolves to undefined.
    if (tree !== undefined || !share || !treeIndexMatchesClient) return false

    // Regime PDF downloads render /pdf/* routes in headless Chrome without the schedulePrint
    // param. Raising the alert there prints the dialog and clears the remaining share context.
    return !schedulePrint && !pathname.startsWith("/pdf")
}
